import { Component } from '@angular/core';

interface HowToStep {
  num: string;
  title: string;
  body: string[];
  highlight?: string;
  images: string[];
  showSocial?: boolean;
  badge: string;
}

interface CreditStep {
  num: string;
  title: string;
  icon: string;
}

interface HardshipItem {
  icon: string;
  label: string;
}

@Component({
  selector: 'app-how-to',
  templateUrl: './how-to.component.html',
  styleUrls: ['./how-to.component.css']
})
export class HowToComponent {

  isNavOpen = false;

  steps: HowToStep[] = [
    {
      num: '1',
      title: 'Register at UmyoGossip.site',
      body: ['Go to UmyoGossip.site and create your account.'],
      highlight: 'You must register first.',
      images: ['assets/images/howto/laptop.png'],
      badge: 'assets/images/howto/card-step-1.png'
    },
    {
      num: '2',
      title: 'Complete Your Profile',
      body: ['After registering: Menu → Profile → Complete Profile.', 'Make sure your profile information is completed before applying for your referral code.'],
      images: ['assets/images/howto/complete-profile.png'],
      badge: 'assets/images/howto/card-step-2.png'
    },
    {
      num: '3',
      title: 'Apply For Your Referral Code',
      body: ['From your Profile: press "Apply for Referral".', 'Once approved, your unique referral code is automatically added to your UMYO digital card. There is no need to manually type or add the referral code.'],
      images: ['assets/images/howto/creater-card.png'],
      badge: 'assets/images/howto/card-step-3.png'
    },
    {
      num: '4',
      title: 'Share Your UMYO Digital Card',
      body: ['Share your digital card with your followers, supporters, family, friends, businesses, and community.', 'Use the platforms you already use.'],
      highlight: 'No additional content required.',
      images: ['assets/images/howto/share-card.png'],
      showSocial: true,
      badge: 'assets/images/howto/card-step-4.png'
    },
    {
      num: '5',
      title: 'Members & Businesses Register',
      body: ['Your followers can become participating members with memberships starting as low as $2.54/month.', 'Businesses can participate starting as low as $49.99/month.', 'As your participating community grows, your referral activity is tracked.'],
      images: ['assets/images/howto/resident.png', 'assets/images/howto/business.png'],
      badge: 'assets/images/howto/card-step-5.png'
    },
    {
      num: '6',
      title: 'Track Your Community',
      body: ['Your Creator Dashboard allows you to follow the growth connected to your referral code: Members, Businesses, Referrals, Activity, Earnings.', 'You can see the community you are helping build.'],
      images: ['assets/images/howto/creater-dashboard.png', 'assets/images/howto/member-register.png'],
      badge: 'assets/images/howto/card-step-6.png'
    }
  ];

  creditSteps: CreditStep[] = [
    { num: '1', title: 'Your Card', icon: 'assets/images/howto/card-referral.png' },
    { num: '2', title: 'Press Sign Up', icon: 'assets/images/howto/flow-signup.png' },
    { num: '3', title: 'Complete Registration', icon: 'assets/images/howto/flow-clipboard.png' },
    { num: '4', title: 'Referral Tracked', icon: 'assets/images/howto/flow-credited.png' }
  ];

  hardshipItems: HardshipItem[] = [
    { icon: 'assets/images/howto/icon-gas.png', label: 'Gas' },
    { icon: 'assets/images/howto/icon-food.png', label: 'Food' },
    { icon: 'assets/images/howto/icon-electricity.png', label: 'Electricity' },
    { icon: 'assets/images/howto/icon-transportation.png', label: 'Transportation' },
    { icon: 'assets/images/howto/icon-housing.png', label: 'Housing' },
    { icon: 'assets/images/howto/icon-daycare.png', label: 'Day Care' },
    { icon: 'assets/images/howto/icon-military.png', label: 'Military Family Support' },
    { icon: 'assets/images/howto/icon-single-parent.png', label: 'Single Mother / Father Support' },
    { icon: 'assets/images/howto/icon-emergency-health.png', label: 'Emergency Health Support' },
    { icon: 'assets/images/howto/icon-other-hardship.png', label: 'Other Hardship Assistance' }
  ];

  summaryList = [
    { symbol: '⇄', text: 'You Share.' },
    { symbol: '☝', text: 'They Press Sign Up.' },
    { symbol: '✓', text: 'The System Tracks It.' },
    { symbol: '$', text: 'You Can Earn.' },
    { symbol: '♥', text: 'The Community Can Benefit.' }
  ];
}